import { Link, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Logo } from "../common/Logo";
import { BrutalButton } from "../common/Brutal";

const MENU = [
  { label: "Festival Info", to: "/festival-info" },
  { label: "Artists", to: "/artists" },
  { label: "Schedule", to: "/schedule" },
  { label: "Competition", to: "/competition" },
  { label: "Experience", to: "/experience" },
  { label: "Livestream", to: "/livestream" },
];

export const LandingHeader = () => {
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  // Smooth-scroll to hash when on Landing
  useEffect(() => {
    if (!loc.hash) return;
    const id = loc.hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [loc.hash, loc.pathname]);

  const goTo = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      // anchor on landing
      if (loc.pathname !== "/") nav(to);
      else {
        const id = to.replace("/#", "");
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      return;
    }
    nav(to);
  };

  return (
    <header className="sticky top-0 z-40 bg-[#FFF4E6]/95 backdrop-blur-md border-b-2 border-[#3D1E6D]" data-testid="landing-header">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="shrink-0"><Logo /></Link>
        <div className="flex items-center gap-2">
          <Link to="/login" data-testid="camper-login-link">
            <BrutalButton variant="primary">Login / Sign Up</BrutalButton>
          </Link>
          {/* Mobile menu toggle */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden kf-border bg-white p-2"
            aria-label="Toggle menu"
            data-testid="menu-toggle"
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
              {open ? <path d="M6 6l12 12M6 18L18 6" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
            </svg>
          </button>
        </div>
      </div>

      {/* Desktop nav strip — persistent below logo row */}
      <nav className="hidden md:block border-t border-[#3D1E6D]/15 bg-[#FFF4E6]/80" data-testid="landing-menu-desktop">
        <ul className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-1 overflow-x-auto no-scrollbar">
          {MENU.map((m) => (
            <li key={m.label}>
              <button
                type="button"
                onClick={() => goTo(m.to)}
                className="px-3 py-1.5 text-xs font-bold tracking-[0.2em] uppercase text-[#3D1E6D] hover:bg-[#FFB400] kf-border-transparent border-2 border-transparent hover:border-[#3D1E6D] transition-colors whitespace-nowrap"
                data-testid={`menu-${m.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {m.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>

      {/* Mobile dropdown menu */}
      {open && (
        <nav className="md:hidden bg-white border-t-2 border-[#3D1E6D]" data-testid="landing-menu-mobile">
          <ul className="px-4 py-2 space-y-1">
            {MENU.map((m) => (
              <li key={m.label}>
                <button
                  type="button"
                  onClick={() => goTo(m.to)}
                  className="w-full text-left px-3 py-2 text-sm font-bold uppercase tracking-widest text-[#3D1E6D] hover:bg-[#FFB400] border-b border-[#3D1E6D]/10"
                  data-testid={`menu-mobile-${m.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {m.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
};
